import React from 'react';

export const HALF_WIDTH = { upper: 22, lower: 23 };

export const NAME = { upper: 'Ikkinchi kichik oziq tish', lower: 'Ikkinchi kichik oziq tish' };

/*
 * Upper second premolar: two cusps of equal height and a shallower fissure than
 * the first premolar, carried by a single root that keeps the longitudinal
 * groove of its two-rooted neighbour.
 */
const UPPER_OUTLINE = `M 34 52
    C 30.8 60 28.8 66.4 28.4 72.4
    C 28.2 78.4 29.8 84.4 33 88
    L 41.6 94.4
    Q 43.8 96 46 94.2
    L 49.8 89.4
    Q 50.2 89 50.6 89.4
    L 54.8 94
    Q 57 95.6 59 93.8
    L 67 87.4
    C 70.2 84.4 71.8 78.4 71.6 72
    C 71.4 64.6 68.8 56.4 66 52
    C 65.6 46 65.4 38 64.6 30
    C 63.8 22.4 62.2 14.6 60 11
    C 58 7.8 53.2 7.2 50.6 10
    C 47.8 13 45 24 42.4 33
    C 39.8 41 36.6 47 34 52 Z`;

const UPPER_CERVICAL = 'M 34 52 C 40 46.4 60 46.4 66 52';

const UPPER_DETAILS = [
    'M 50.2 89.2 C 50 82.6 50 75 50.2 68',
    'M 44.2 93 C 44.6 86 44.8 80 44.4 74',
    'M 56.6 92.6 C 56.2 86 56 80 56.4 74',
    /* Longitudinal groove of the single root. */
    'M 52.2 46 C 52.8 38 53 28 52.4 19',
];

/*
 * Lower second premolar: larger than the first, with a well developed lingual
 * cusp, so the two cusps are nearly level and the fissure sits centrally.
 * Single, stout root.
 */
const LOWER_OUTLINE = `M 33 46
    C 30.4 36 28.4 26.4 28.2 19.4
    C 28.1 13 30.2 8 33.8 5.6
    Q 36.6 3.8 40.4 4.2
    L 43.6 3.2
    Q 45.8 2.4 47.2 4.4
    L 52 13.4
    Q 52.8 14.8 54 13.6
    L 58.6 8.4
    Q 60.8 6.2 62.8 8.4
    C 65.6 11.6 67 17 67 23.4
    C 67 31.4 66.6 39 66 46
    C 67.8 56 68 68 66.4 77.4
    C 65.2 85.4 62.8 91 59.6 93.4
    Q 55.4 96.4 51 95
    C 47.6 94 45 90 43.4 84
    C 41.2 76 39.8 64.6 39 55
    C 38.6 51 37.2 48.4 33 46 Z`;

const LOWER_CERVICAL = 'M 33 46 C 40 50.6 59 50.6 66 46';

const LOWER_DETAILS = [
    'M 53 14 C 52.6 22 52.4 30 52.6 38',
    'M 46 5 C 46.6 14 47 24 47 34',
    'M 60.4 10.4 C 60 18 59.8 26 60.2 34',
    'M 52 56 C 52.4 66 52.4 78 51.8 88',
];

export default function SecondPremolar({ jaw }) {
    const isUpper = jaw === 'upper';

    return (
        <>
            <path d={isUpper ? UPPER_OUTLINE : LOWER_OUTLINE} className="dental-tooth__body" />
            <path d={isUpper ? UPPER_CERVICAL : LOWER_CERVICAL} className="dental-tooth__line" />
            {(isUpper ? UPPER_DETAILS : LOWER_DETAILS).map((d) => (
                <path key={d} d={d} className="dental-tooth__detail" />
            ))}
        </>
    );
}
